import { useEffect, useState } from 'react';
import { PORTAL_MOBILE_MAX_WIDTH_PX } from './constants';
/**
 * 是否为门户手机 Web 布局（与 CSS 767px 断点一致）。
 *
 * @returns {boolean}
 */
export function useIsPortalMobile() {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') {
            return false;
        }
        return window.matchMedia(`(max-width: ${PORTAL_MOBILE_MAX_WIDTH_PX}px)`).matches;
    });
    useEffect(() => {
        const media = window.matchMedia(`(max-width: ${PORTAL_MOBILE_MAX_WIDTH_PX}px)`);
        const onChange = () => setIsMobile(media.matches);
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, []);
    return isMobile;
}
